
import { BehaviorSubject } from 'rxjs';

export const behaviorSubjectCartItem$ = new BehaviorSubject({});

export const behaviorSubjectCartItem = behaviorSubjectCartItem$.asObservable();